export default "__VITE_ASSET__BsRH818q__"